var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-4 d-flex justify-center mb-5 py-3"},[_c('v-img',{attrs:{"src":_vm.image,"max-width":"150","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }